'use client';

import { useFormContext, useWatch } from 'react-hook-form';

import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { RegisterCard } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import {
  PasswordField,
  TextField,
} from '@eliadmin/core/src/components/dlz/auth/register/register-fields';
import type { RegisterFormInput } from '@eliadmin/core/src/components/dlz/auth/register/register-schema';
import { PasswordStrength } from '@eliadmin/core/src/components/dlz/forms/password-strength';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** Figma „Prihlasovacie údaje“ (60260:29878): e-mail, new password with the strength meter, repeat. */
export function CredentialsCard() {
  const { t } = useTranslations();
  const { control } = useFormContext<RegisterFormInput>();
  const password = useWatch({ control, name: 'password' });

  return (
    <RegisterCard title={t('text385')} spacing="spacious">
      <div className="flex flex-col gap-4">
        <TextField
          name="email"
          type="email"
          inputMode="email"
          autoComplete="email"
          label={t('text35')}
          required
          hint={REGISTER_COPY.credentials.emailHint}
          placeholder={REGISTER_COPY.credentials.emailPlaceholder}
        />
        <div className="grid items-start gap-4 md:grid-cols-2">
          <div className="flex flex-col gap-2">
            <PasswordField
              name="password"
              label={t('text203')}
              required
              autoComplete="new-password"
              placeholder={REGISTER_COPY.credentials.passwordPlaceholder}
            />
            {/* Phone design: label and list sit 2 / 6 px closer to the bars than on desktop. */}
            <PasswordStrength
              value={password}
              className="max-md:gap-2 max-md:[&>div:first-child]:gap-1.5"
            />
          </div>
          <PasswordField
            name="password_confirmation"
            label={REGISTER_COPY.credentials.repeatPassword}
            required
            autoComplete="new-password"
            placeholder={REGISTER_COPY.credentials.passwordPlaceholder}
          />
        </div>
      </div>
    </RegisterCard>
  );
}
